import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    valores: {
        display: "flex",
        justifyContent: "space-between",
    }
}))